import { forwardRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";

import { SidebarCollapsibleProps } from "./SidebarCollapsible.type";

const SidebarCollapsible = forwardRef<HTMLButtonElement, SidebarCollapsibleProps>(
	({ active = false, children, disabled = false, label, onClick, url, title }, ref) => {
		const navigate = useNavigate();

		const handleButtonClick = useCallback(() => {
			if (disabled) return;

			if (url) {
				navigate(url);
			}

			if (typeof onClick === "function") {
				onClick();
			}
		}, [disabled, navigate, onClick, url]);

		return (
			<ul className="mt-4">
				<li>
					<button
						className={classNames(
							"group flex w-full items-center justify-between px-2 py-1 text-base font-normal transition duration-75 sidebar__scrollable-item",
							{
								"text-white hover:bg-tertiary-hover": !active && !disabled,
								"bg-tertiary-hover hover:bg-tertiary-hover text-white": active && !disabled,
								"text-white cursor-default": disabled,
							},
						)}
						title={title}
						onClick={handleButtonClick}
						ref={ref}
					>
						<span className="ml-2 flex-1 text-left shrink flex items-start gap-4">
							<span className="w-2 h-2 rounded-full bg-white shrink-0 mt-2"></span>
							<span dangerouslySetInnerHTML={{ __html: label }}></span>
						</span>
					</button>
				</li>
				<ul className="py-1">
					{children}
				</ul>
			</ul>
		);
	},
);

export { SidebarCollapsible };
